import React from "react"

import Layout from "../components/common/layout/layout"
import SEO from "../components/common/layout/seo"
import Navigation from "../components/common/navigation/navigation"

import Header from "../components/sections/header"
import Features from "../components/sections/features"
import Footer from "../components/sections/footer"
import GetStarted from "../components/sections/getstarted"
import Fqa from "../components/sections/faq"
import Pricing from "../components/sections/pricing"

const IndexPage = () => (
  <Layout>
    <SEO title="Cocatus" />
    <Navigation />
    <Header />
    <Features />
    <GetStarted />
    {/* <Pricing /> */}
    <Fqa />
    {/* <Footer /> */}
  </Layout>
)

export default IndexPage
